import React from 'react'
import {
  SelectEntitiesModalDataContext,
  SelectEntitiesModalDataContextType
} from './context'
import { SearchableEntity } from './SelectEntitiesForm.types'

type ProvideFetchedEntitiesProps = {
  entities: SearchableEntity[]
}

export const ProvideFetchedEntities: React.FC<ProvideFetchedEntitiesProps> = ({
  entities,
  children
}) => {
  const contextValue = React.useMemo(
    (): SelectEntitiesModalDataContextType => ({
      entities
      // you can pass additional info about resources (like entities types) here
      // so, context value should be an object
    }),
    [entities]
  )

  return (
    <SelectEntitiesModalDataContext.Provider value={contextValue}>
      {children}
    </SelectEntitiesModalDataContext.Provider>
  )
}
